/* eslint-disable no-console */
<template>
  <div class="main_unit">
    <div class="top_unit">
      <div class="top_name_box">{{brandStoreName}}</div>
      <div v-if="releaseExist" class="top_right_box_mgt release_info_box"><p class="release_category">{{releaseCategory}}</p>
        <div class="release_link_box" >
          <a :href="releaseUrl" target="_blank" rel="noopener noreferrer" class="icn_back_black router-link-active">
            {{releaseContents}}
          </a>
        </div>
      </div>
      <div class="top_center_box"> </div>
    </div>
    <div class="menu_top_unit">
      <p class="menu_staff_tit"></p>
      <div class="menu_staff_box">
        <ul>
          <li v-for="(menu, index) in staffMenu" :key="menu.id" :class="classList['li'][index]">
            <a href="#" v-show="menu.displayFlg" :class="classList['a'][menu.index-1]" role="button" @click.prevent.stop="openNameListModal(menu)">
              <p class="menu_staff_tit_s" :id="menu.index">{{menu.upperButtonName}}</p>{{menu.lowerButtonName}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="menu_top_unit">
      <p class="menu_kanri_tit"></p>
      <div class="menu_kanri_box">
        <ul>
          <li v-for="menu in managerMenu2" :key="menu.id" >
            <a href="#" role="button" @click.prevent.stop="openNameListModal2(menu)" :style="menu.disable ? 'background-color: #ddd; color: #aaa; border-color: #aaa;' : ''">{{menu.title}}</a>
          </li>
          <li v-for="menu in managerMenu1" :key="menu.id" >
            <a href="#" role="button" @click.prevent.stop="openLoginModal(menu)" :style="menu.disable ? 'background-color: #ddd; color: #aaa; border-color: #aaa;' : ''">{{menu.title}}</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="overlay" v-show="showModal.nameList">
      <div >
        <div class="modal_box wd720">
          <div class="modal_header_unit">
            <div class="modal_header_box">
              <p class="modal_header_tit">名前を選択してください</p>
            </div>
            <div class="modal_header_left">
              <a class="js-modal-close" role="button" @click.prevent.stop="dismiss('nameList')">キャンセル</a>
            </div>
            <div class="modal_header_right">
              <input class="modal_text_field" type="text" v-model="searchWord" placeholder="スタッフ名検索">
            </div>
          </div>
          <div class="modal_content_box">
            <ul>
              <li v-for="staff in filteredDatas" class="d-flex justify-content-between align-items-center" role="button" :key="staff.staffId" @click.prevent.stop="select(staff)">
                <div>
                  {{staff.staffName}}
                </div>
                <div>
                  <span v-if="selectedStaff && selectedStaff.staffId === staff.staffId"><i class="fas fa-check"></i></span>
                </div>
              </li>
            </ul>
          </div>
          <div class="btn_submit letter_spa">
            <a role="button" @click.prevent.stop="nextPage">決定</a>
          </div>
        </div>
      </div>
    </div>
    <div class="overlay" v-show="showModal.login">
      <div>
        <div class="modal_box wd720">
          <div class="modal_header_unit">
            <div class="modal_header_box">
              <p class="modal_header_tit_s"> </p>
              <p v-if="selectedManageButton !== null && selectedManageButton.id === 2" class="modal_header_tit">報告書一覧 パスワードを入力してください</p>
              <p v-else class="modal_header_tit">パスワードを入力してください</p>
            </div>
            <div class="modal_header_left">
              <a class="js-modal-close" href="#" role="button" @click.prevent.stop="dismiss('login')" >閉じる</a>
            </div>
          </div>
          <form @submit.prevent="login">
            <div class="modal_password_unit">
              <div class="modal_password_box">
                <input type="text" name="username" value="manager" autocomplete="username" tabindex="-1" aria-hidden="true" style="position: absolute; opacity: 0; width: 0; height: 0; z-index: -1; pointer-events: none;">
                <input type="password" class="wd240 password_box" v-model="pwText" name="password" autocomplete="current-password">

              </div>
              <p class="text-danger">{{loginError}}</p>
              <div class="btn_submit">
                <button type="submit">OK</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="overlay" v-show="showModal.healthAlert">
      <div>
        <div class="modal_box wd720">
          <div class="modal_header_unit">
            <div class="modal_header_box">
              <p class="modal_header_tit"><img src="../assets/img/inc_alert_on_header.png">警告</p>
            </div>
          </div>
          <div class="modal_content_tex">
            <p class="text_white_space_pre_wrap" style="overflow-y: auto;width: 100%;max-height: 200px">{{message}}</p>
          </div>
          <div class="btn_submit">
            <a href="#" role="button" @click.stop.prevent="closeHealthAlert()">了解</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'TopMenu',
    components: {},
    data: function () {
      return {
        pwText: '',
        selectedStaff: null,
        selectedButton: null,
        selectedManageButton: null,
        role: '',
        staffMenu: null,
        showModal: {
          nameList: false,
          login: false,
          healthAlert:false,
        },
        loginError: '',
        managerMenu1: [
          {id: 3, title: "温度・湿度管理一覧", to: {name: 'manageTemperatureList'}, disable: false},
          {id: 2, title: "報告書一覧", to: {name: 'calendar'}, disable: false},
          {id: 5, title: "ダッシュボード", to: {name: 'dashboard'}, disable: false},
          {id: 4, title: "設定メニュー", to: {name: 'managemenu'}, disable: false},
        ],
        managerMenu2: [
          {id: 1, title: "衛生管理計画書", to: {name: 'plan'}, disable: false},
        ],
        staffList: [],
        searchWord:'',
        releaseExist:false,
        releaseCategory:"",
        releaseContents:"",
        releaseCategories:["メンテナンス情報"],
        releaseUrl:"",
        healthExistsCheckError:false,
        message:"",
      }
    },
    computed: {
      brandPath: function () {
        return this.$route.params.brandPath
      },
      brand: function () {
        return this.$store.getters['brand/data']
      },
      brandStoreName: function () {

        if (this.$route.params.brandPath === process.env.VUE_APP_ADMIN_BRAND_PATH) {
          return ''
        }

        let brandName = this.$store.getters['brand/name']
        let storeName = this.$store.getters['store/name']

        if (brandName == null) {
          brandName = ''
        }

        if (storeName == null) {
          storeName = ''
        }

        return brandName + ' ' + storeName
      },
      classList: function () {
        let list = {
          li: [
            'staff_4side',
            '',
            'staff_4side',
            'staff_4center',
          ],
          a: [
            'top_bg01',
            'top_bg02',
            'top_bg03',
            'top_bg04',
          ]
        }
        if (this.staffMenu.length < 3) {
          list.li = [
                  '',
                  '',
                  '',
                  ''
          ]
        }
        return list
      },
      filteredDatas:function(){
        var data = this.staffList;
        var filterWord = this.searchWord && this.searchWord.toLowerCase();
        if(filterWord){
          data = data.filter(function (row){
            return Object.keys(row).some(function (){
              return String(row["staffName"]).toLowerCase().includes(filterWord)
            })
          })
        }
        data = data.filter(function (row){
            return row["authorityKbn"] === 7;
        })
        return data;

      },
    },
    created: function () {
      this.init()
    },
    methods: {
      fetchTopButtonList: function (brandId, brandPath) {
        // APIパス
        const url = this.$apiEndpoint + 'user/' + brandId + '/top?datetime=' + this.dateFormat()
        // API呼び出し
        this.$axios.get(url).then(response => {
          let menu = response['data']['menu']
          let heatStrokeEnable = response['data']['heatStrokeEnable']
          if(heatStrokeEnable == 1){
            this.managerMenu1.unshift( {id: 5, title: "熱中症アラート", to: {name: 'manageHeatStrokeIndexMap'}, disable: false, enable:false});
          }
          // CSSに合わせて並び替え
          let list = menu.map(x => {
            let button = x
            let buttonIndex = x.no

            if (x.no === 2) {
              buttonIndex = 3
            } else if (x.no === 3) {
              buttonIndex = 2
            }
            button.index = buttonIndex

            return button
          })

          list.sort((a, b) => a.index - b.index)

          this.staffMenu = list
          // リリース情報
          let releaseSetting = response['data']['releaseSetting']
          if(releaseSetting != null) {
            this.releaseExist = true;
            this.releaseCategory = this.releaseCategories[releaseSetting['releaseCategoryId']-1];
            this.releaseContents = releaseSetting['contents'];
            this.releaseUrl = releaseSetting['url'];
          }
          this.$store.dispatch('buttons/set', { key: 'top', list: list })
        }).catch((err) => {
          let error = {
            button: {
              path: {name: 'top', params: {brandPath: brandPath}}
            }
          }
          if (err.customError) {
            error = Object.assign(error, err.customError)
          }
          this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
        })
      },
      resetOperatorInfo: function () {
        this.$store.dispatch('manager/logout', this.$cookies)
        this.$store.dispatch('staff/doClear')
      },
      init: function () {
        this.resetOperatorInfo()

        // システム管理者のときはスタッフメニューは表示しない
        if (this.brandPath === process.env.VUE_APP_ADMIN_BRAND_PATH) {
          // 企業と店舗の情報をstoreから削除する
          this.$store.dispatch('brand/doClear')
          this.$store.dispatch('store/doClear')
          this.$store.dispatch('brand/setBrandUrl', process.env.VUE_APP_URL + this.brandPath)
          return
        }

        // ブランド情報と店舗情報が一致しないときは店舗情報を削除
        if (this.brand.id != this.$store.getters['store/brandId']) {
          this.$store.dispatch('store/doClear')
        }

        //メニュー情報の取得処理の呼び出し
        this.fetchTopButtonList(this.brand.id, this.brandPath)

        if (this.$store.getters['attention/show']) {
          this.$store.dispatch('dialog/setDialog', {
            title: 'お知らせ',
            text: this.$store.getters['attention/message'],
            button: {
              cancel: { show: false, text: null },
              done: { show: true, text: '閉じる' }
            },
            next: null,
            show: true,
          })
          this.$store.dispatch('attention/setMessage', '')
          this.$store.dispatch('attention/setShow', false)
        }
      },
      setRequestStaff: function (userId, userName) {

        const userInfo = this.brand.company_name + ' ' + this.brand.brand_name + ' ' + this.$store.getters['store/name'] + ' ' + userId + ' ' + userName
        this.setRequester('STAFF', userInfo)
      },
      setRequestManager: function (kbn) {
        let userInfo = ''

        const brandInfo = this.brand.company_name + ' ' + this.brand.brand_name

        // 権限区分ごとに設定
        switch (kbn) {
          case 1:
            //システム管理者
            userInfo = 'システム管理者'
            break;
          case 2:
            //企業管理者
            userInfo = brandInfo + ' ' + '企業管理者'
            break;
          case 3:
            //店舗管理者（共通）
            userInfo = brandInfo + ' '  + '店舗管理者（共通）'
            break;
          case 4:
            //店舗管理者（個別）
            userInfo = brandInfo + ' ' + this.$store.getters['store/name'] + ' '  + '店舗管理者（個別）'
            break;
        }

        this.setRequester('MANAGER', userInfo)
      },
      setRequester: function (type, info) {
        let user = {}
        user.type = type
        user.info = info
        this.$store.dispatch('user/setUser', user)
      },
      login: async function () {
        const beforeStoreId = this.$store.getters['store/id']
        this.loginError = ''

        // ログイン
        await this.$store.dispatch('manager/login', {
            axios: this.$axios,
            cookies: this.$cookies,
            endpoint: this.$apiEndpoint,
            password: this.pwText
        }).catch(error => {
          if (error.customError) {
            this.loginError = error.customError.message
          } else {
            this.loginError = error.message
          }
        })

        // エラーがあったら中断
        if (this.loginError !== '') {
          return
        }

        // 店舗情報取得
        const kbn = this.$store.getters['manager/authorityKbn']
        const managerBrandId = this.$store.getters['manager/brandId']

        // ブランドURLに合ったログインをしていない
        if (! this.checkBrandPath(kbn, managerBrandId)) {
          this.loginError = 'URLとパスワードをもう一度ご確認ください。'
          return
        }

        // リクエストユーザー設定
        this.setRequestManager(kbn)

        // 店舗管理者
        if (kbn == 4) {
          try {
            const afterStoreId = this.$store.getters['manager/storeId']
            await this.$store.dispatch('store/fetchStore', {
              axios: this.$axios,
              endpoint: this.$apiEndpoint,
              brandId: managerBrandId,
              storeId: afterStoreId
            })

            this.$store.dispatch('manager/setStoreManagerRole', this.role)

            if (beforeStoreId != afterStoreId) {
              this.$store.dispatch('attention/setMessage', '店舗情報が切り替わりました。')
              this.$store.dispatch('attention/setShow', true)
              
              this.$store.dispatch('dialog/setDialog', {
                title: 'お知らせ',
                text: '表示されている店舗情報が切り替わります。\nご留意ください。',
                button: {
                  cancel: { show: false, text: null },
                  done: { show: true, text: '閉じる' }
                },
                next: null,
                show: true,
              })
            }

          } catch (err) {
            let error = {
              button: {
                path: {name: 'top', params: {brandPath: this.brandPath}}
              }
            }
            if (err.customError) {
              error = Object.assign(error, err.customError)
            }
            this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
            return
          }
        }

        // リクエストユーザー設定
        this.setRequestManager(kbn)

        // 画面遷移
        if(this.selectedManageButton.id === 2 && (kbn == 2 || kbn == 6)){
          this.$store.dispatch('buttons/setSelectedManageButton', this.selectedManageButton);
          this.$router.push({name: "manageStoredSelect", params: { brandPath: this.brandPath }})
        }
        else if(this.selectedManageButton.id === 3){

          if(kbn == 2 || kbn == 6){
            this.$store.dispatch('buttons/setSelectedManageButton', this.selectedManageButton);
            this.$router.push({name: "manageStoredSelect", params: { brandPath: this.brandPath }})
          }
          else if(kbn == 4){
            this.selectedManageButton.to.name = "storeTemperatureList";
            this.$store.dispatch('buttons/setSelectedManageButton', this.selectedManageButton);
            this.showModal.login = false;
            this.openNameListModal2(this.selectedManageButton)
          } else {
            this.$router.push({name: this.selectedManageButton.to.name, params: {brandPath: this.brandPath}})
          }
        }
        else{
          this.$router.push({name: this.selectedManageButton.to.name, params: { brandPath: this.brandPath }})
        }
      },
      checkBrandPath: function (kbn, brandId) {
        // ブランドパスが違う
        if (kbn == 1) {
          return this.brandPath === process.env.VUE_APP_ADMIN_BRAND_PATH
        }

        if (this.brand.id != brandId) {
          return false
        }

        return true
      },
      select: function (staff) {
        this.selectedStaff = staff
      },
      nextPage: async function () {
        if(this.selectedStaff != null) {
            this.showModal.nameList = false;
            let brandId = this.$store.getters['brand/id']
            let storeId = this.$store.getters['store/id']
            // 遷移
            const buttons = {
              1: 'dailyCheckMenuIndex',
              2: 'cookingCheckIndex',
              3: 'healthCheckInput',
              4: 'dailyCheckMenuIndex'
            }

            this.healthExistsCheckError = false;
            try {
              if (this.selectedButton) {
                var pkStaffId = this.selectedStaff.id;
                var datetime = this.dateFormat();
                var button = this.staffMenu.find(item => item.no == 3);

                //健康身だしなみボタン以外を選択
                if (this.selectedButton.no != 3) {

                  if (button !== undefined && button !== null) {
                    var topButtonId = button.id;

                    //身だしなみチェック履歴取得API
                    const res = await this.$axios.get(this.$apiEndpoint + 'user/brand/' + brandId + '/top/' + topButtonId + '/store/' + storeId + '/staff/' + pkStaffId + '/exists?date=' + datetime)
                    this.healthExistsCheckError = !res.data.isExists;
                    var unCheckItemName = res.data.unCheckItemName;
                  }
                }
                //健康身だしなみ以外を選択かつ身だしなみ未実施がある場合
                if (this.selectedButton.no != 3 && this.healthExistsCheckError) {
                  //アラート通知
                  this.message = button.upperButtonName + " " + button.lowerButtonName + "\n"
                  unCheckItemName.forEach(item => {
                    this.message += "【" + item + "】\n";
                  });

                  this.message += "のチェックが行われていません。\n対応してから再度実施してください。";

                  this.showModal.healthAlert = true;
                } else {
                  // 選択中スタッフ
                  this.setRequestStaff(this.selectedStaff.staffId, this.selectedStaff.staffName)
                  this.$store.dispatch('staff/doUpdate', this.selectedStaff)
                  // 画面遷移
                  this.$router.push({name: buttons[this.selectedButton.no], params: {menuId: this.selectedButton.id}})
                }
              } else {
                // 選択中スタッフ
                this.setRequestStaff(this.selectedStaff.staffId, this.selectedStaff.staffName)
                this.$store.dispatch('staff/doUpdate', this.selectedStaff)
                // 画面遷移
                this.$router.push({name: this.selectedManageButton.to.name, params: {brandPath: this.brandPath}})
              }
            } catch (err) {
              let error = {
                button: {
                  path: {name: 'top', params: {brandPath: this.brandPath}}
                }
              }

              if (err.customError) {
                error = Object.assign(error, err.customError)
              }
              this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
            }
        }
      },
      openNameListModal2:async function (button) {

        this.initNameListModal().then((res) => {
          if(!res){
            return
          }
          this.selectedButton = null;
          this.selectedManageButton = button;
          this.showModal.nameList = true;
        })
      },
      openNameListModal: function (button) {

        this.initNameListModal().then((res) => {
          if(!res){
            return
          }
          this.selectedButton = button
          this.selectedManageButton = null;
          this.showModal.nameList = true
        })
      },
      initNameListModal:async function () {

        let brandId = this.$store.getters['brand/id']
        let storeId = this.$store.getters['store/id']

        // 店舗情報を取得していないのに画面遷移しようとしたら警告
        if (storeId === null || ! this.$cookies.get('user-api-token')) {
          this.$store.dispatch('dialog/setDialog', {
            title: '店舗情報取得エラー',
            text: 'スタッフ画面を表示できません。\n管理画面へアクセスし、\n店舗管理者のログイン操作を実施してください。',
            button: {
              cancel: { show: false, text: null },
              done: { show: true, text: '閉じる' }
            },
            next: null,
            show: true,
          })

          return false;
        }

        // ユーザ一覧 DBデータ取得
        try {
          const res = await this.$axios.get(this.$apiEndpoint + 'user/brand/' + brandId + '/store/' + storeId + '/staff')
          this.staffList = res.data.staffList
        } catch (err) {
          let error = {
            button: {
              path: {name: 'top', params: {brandPath: this.brandPath}}
            }
          }

          if (err.customError) {
            error = Object.assign(error, err.customError)
          }
          this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
        }

        return true;
      },
      dismiss: function (type) {
        this.showModal[type] = false

        if (type === 'nameList') {
          this.selectedButton = null
          this.selectedStaff = null
        }

        if (type === 'login') {
          this.selectedManageButton = null
          this.loginError = ''
          this.pwText = ''
        }

      },
      openLoginModal: function (manageButton) {
        // PH3対応
        if (manageButton.disable) {
          return
        }
        this.selectedManageButton = manageButton
        if(this.selectedManageButton.id === 3){
          this.initNameListModal2().then((res) => {
            if(!res){
              this.showModal.login = true
              return
            }
            this.selectedButton = null;
            this.selectedManageButton.to.name = "storeTemperatureList";
            this.$store.dispatch('buttons/setSelectedManageButton', this.selectedManageButton);
            this.showModal.nameList = true;
          })
        } else {
          this.showModal.login = true
        }

      },
      dateFormat(){
        let nowDate = new Date();
        let year = nowDate.getFullYear();
        let month = ("0" + (nowDate.getMonth()+1)).slice(-2);
        let day = ("0" + nowDate.getDate()).slice(-2);
        let hours = ("0" + nowDate.getHours()).slice(-2);
        let minutes = ("0" + nowDate.getMinutes()).slice(-2);
        let seconds = ("0" + nowDate.getSeconds()).slice(-2);

        let format_str = 'YYYYMMDDhhmmss'
        format_str = format_str.replace(/YYYY/g,year);
        format_str = format_str.replace(/MM/g,month);
        format_str = format_str.replace(/DD/g,day);
        format_str = format_str.replace(/hh/g,hours);
        format_str = format_str.replace(/mm/g,minutes);
        format_str = format_str.replace(/ss/g,seconds);
        return format_str;
      },
      initNameListModal2:async function () {

        let brandId = this.$store.getters['brand/id']
        let storeId = this.$store.getters['store/id']

        // 店舗情報を取得していないのに画面遷移しようとしたら警告
        if (storeId === null || ! this.$cookies.get('user-api-token')) {
          return false;
        }

        // ユーザ一覧 DBデータ取得
        try {
          const res = await this.$axios.get(this.$apiEndpoint + 'user/brand/' + brandId + '/store/' + storeId + '/staff')
          this.staffList = res.data.staffList
        } catch (err) {
          let error = {
            button: {
              path: {name: 'top', params: {brandPath: this.brandPath}}
            }
          }

          if (err.customError) {
            error = Object.assign(error, err.customError)
          }
          this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
        }

        return true;
      },
      closeHealthAlert:function(){
        this.message = "";
        this.healthExistsCheckError = false;
        this.showModal.healthAlert = false;
      }
    }
  }

</script>
